import { render } from "./Login.vue?vue&type=template&id=1979252c&scoped=true&ts=true"
import script from "./Login.vue?vue&type=script&setup=true&lang=ts"
export * from "./Login.vue?vue&type=script&setup=true&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=1979252c&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1979252c"],['__file',"src/views/me/Login.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1979252c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1979252c', __exports__)) {
    console.log('reload')
    api.reload('1979252c', __exports__)
  }
  
  module.hot.accept("./Login.vue?vue&type=template&id=1979252c&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('1979252c', render)
  })

}


export default __exports__